import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { Global } from '../classes/Global';
import { StringHelper } from '../helpers/StringHelper';
import { ThemeService } from '../theme.service';

@Component({
  selector: 'app-search-suggestions',
  templateUrl: './search-suggestions.component.html',
  styleUrls: ['./search-suggestions.component.scss'],
  providers: [ ThemeService ]
})
export class SearchSuggestionsComponent extends BaseComponent implements OnInit {

  @Input() inputValue: string;
  private _suggestions: Array<any> = [];

  @Input()
  set suggestions(value: Array<any>) {
    this._suggestions = value instanceof Array ? value : [];
  }

  get suggestions(): Array<any> {
    return this._suggestions;
  }
  @Output() onSearchClicked = new EventEmitter();

  constructor(
    private themeService: ThemeService
  ) {
    super();
  }

  ngOnInit() {
  }

  isDarkTheme(): boolean {
    return this.themeService.isDarkTheme();
  }

  hasSuggestions(): boolean {
    return this.suggestions.length > 0;
  }

  getSuggestionThumbnail(suggestion): string {
    const parts = suggestion.thumbnail ? suggestion.thumbnail.split(',') : [];
    if (parts.length > 0) {
      return parts[parts.length - 1];
    }
    return "";
  }

  getSuggestionItemLink(suggestion: any): string {
    let mediaType = suggestion.mediaType;
    if ((suggestion.itemType === 'season' || suggestion.mediaType === 'tv')) {
      mediaType = 'seasons';
    }
    return "/" + Global.getCountry() + "/" + Global.getStoreUrl() + "/" + mediaType + "/" + suggestion.idInStore;
  }

  getSuggestionActorsAndDirectors(suggestion: any): string {
    if (!suggestion) {
      return "";
    }
    const names = [];
    if (suggestion.actors) {
      names.push(suggestion.actors);
    }
    if (suggestion.directors) {
      names.push(suggestion.directors);
    }
    //Show maximum 3 names in total
    const parts = names.join(', ').split(',');
    return parts.slice(0, 3).join(',');
  }

  getSearchAlt(): string {
    return this.getString('findDeals');
  }

  getSuggestionsSeeAllResultsText(): string {
    return StringHelper.format(this.getString('seeAllResultsFor'), this.inputValue);
  }

  searchClick() {
    this.onSearchClicked.emit();
  }

}
